import { useMemo } from 'react';

import type { EntityType } from '@/core/graphql/generated/types';

import { resolveUnavailableFieldIds } from '../fields/registry';
import { useGetDcrSetupQuery } from '../graphql/query/GetDCRSetup.hook';

type Props = {
	enabled: boolean;
	entityType: EntityType;
	countryId: string | null | undefined;
};

export const useUnavailableFields = ({
	enabled,
	entityType,
	countryId
}: Props) => {
	const { data, loading, error } = useGetDcrSetupQuery({
		skip: !enabled || !countryId,
		variables: { countryId: countryId ?? '' }
	});

	const backendNames = useMemo(
		() =>
			data?.dcrUnavailableFields.__typename === 'UnavailableFields'
				? data.dcrUnavailableFields.results
				: [],
		[data]
	);

	const unavailableFieldIds = useMemo(
		() => resolveUnavailableFieldIds(entityType, backendNames),
		[entityType, backendNames]
	);

	const unavailableNames = useMemo(
		() =>
			Array.from(
				new Set([
					...backendNames,
					...backendNames.map(name => `${name}Id`),
					...unavailableFieldIds
				])
			),
		[backendNames, unavailableFieldIds]
	);

	return {
		unavailableFieldIds,
		unavailableNames,
		loading: loading || !!error
	};
};
